// src/utils/auth.js
export const checkAuth = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
  
    try {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      return tokenData.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  };
  
  export const handleAuthError = (error) => {
    if (error.message.includes('401') || error.message.includes('403')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return true;
    }
    return false;
  };